export default "__VITE_PUBLIC_ASSET__696486d9__"